import { createIcon } from '@chakra-ui/react';

export const InvoiceDocIcon = createIcon({
  displayName: 'InvoiceDocIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="64"
        // height="103"
        viewBox="0 0 87 103"
        fill="none"
      >
        <g filter="url(#filter0_d_2560_37089)">
          <path
            d="M71.0118 87.1992H15.6416C13.1921 87.1992 11.2002 85.2073 11.2002 82.7578V11.6407C11.2002 9.19114 13.1921 7.19922 15.6416 7.19922H71.0118C73.4613 7.19922 75.4532 9.19114 75.4532 11.6407V82.7578C75.4532 85.2073 73.4613 87.1992 71.0118 87.1992Z"
            fill="#FDFEFE"
          />
        </g>
        <path
          d="M24.5789 28.1929C27.5522 28.1929 29.9625 25.7826 29.9625 22.8094C29.9625 19.8361 27.5522 17.4258 24.5789 17.4258C21.6056 17.4258 19.1953 19.8361 19.1953 22.8094C19.1953 25.7826 21.6056 28.1929 24.5789 28.1929Z"
          fill="#C6C6C5"
        />
        <path
          d="M49.5846 24.4255H37.66C36.7717 24.4255 36.0449 23.6987 36.0449 22.8104C36.0449 21.9221 36.7717 21.1953 37.66 21.1953H49.5846C50.4729 21.1953 51.1997 21.9221 51.1997 22.8104C51.1997 23.6987 50.4729 24.4255 49.5846 24.4255Z"
          fill="#C6C6C5"
        />
        <path
          d="M54.8605 41.3551H37.66C36.7717 41.3551 36.0449 40.6284 36.0449 39.7401C36.0449 38.8518 36.7717 38.125 37.66 38.125H54.8605C55.7488 38.125 56.4756 38.8518 56.4756 39.7401C56.4756 40.6553 55.7488 41.3551 54.8605 41.3551Z"
          fill="#C6C6C5"
        />
        <path
          d="M28.3743 41.3551H20.8104C19.9221 41.3551 19.1953 40.6284 19.1953 39.7401C19.1953 38.8518 19.9221 38.125 20.8104 38.125H28.3743C29.2626 38.125 29.9894 38.8518 29.9894 39.7401C29.9625 40.6553 29.2357 41.3551 28.3743 41.3551Z"
          fill="#C6C6C5"
        />
        <path
          d="M54.8605 50.8864H37.66C36.7717 50.8864 36.0449 50.1596 36.0449 49.2713C36.0449 48.383 36.7717 47.6562 37.66 47.6562H54.8605C55.7488 47.6562 56.4756 48.383 56.4756 49.2713C56.4756 50.1596 55.7488 50.8864 54.8605 50.8864Z"
          fill="#C6C6C5"
        />
        <path
          d="M66.0589 65.8786H19.9754C19.0871 65.8786 18.3604 65.1518 18.3604 64.2635C18.3604 63.3752 19.0871 62.6484 19.9754 62.6484H66.0589C66.9472 62.6484 67.674 63.3752 67.674 64.2635C67.647 65.1787 66.9472 65.8786 66.0589 65.8786Z"
          fill="#C6C6C5"
        />
        <path
          d="M28.3743 50.8864H20.8104C19.9221 50.8864 19.1953 50.1596 19.1953 49.2713C19.1953 48.383 19.9221 47.6562 20.8104 47.6562H28.3743C29.2626 47.6562 29.9894 48.383 29.9894 49.2713C29.9625 50.1596 29.2357 50.8864 28.3743 50.8864Z"
          fill="#C6C6C5"
        />
        <path
          d="M66.4085 75.4059H58.8446C57.9563 75.4059 57.2295 74.6791 57.2295 73.7909C57.2295 72.9026 57.9563 72.1758 58.8446 72.1758H66.4085C67.2968 72.1758 68.0236 72.9026 68.0236 73.7909C68.0236 74.6791 67.2968 75.4059 66.4085 75.4059Z"
          fill="#C6C6C5"
        />
        <path
          d="M47.6202 75.4059H20.783C19.8948 75.4059 19.168 74.6791 19.168 73.7909C19.168 72.9026 19.8948 72.1758 20.783 72.1758H47.6202C48.5085 72.1758 49.2353 72.9026 49.2353 73.7909C49.2353 74.6791 48.5085 75.4059 47.6202 75.4059Z"
          fill="#C6C6C5"
        />
        <defs>
          <filter
            id="filter0_d_2560_37089"
            x="0.000195503"
            y="-0.000781059"
            width="86.6529"
            height="102.4"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="5.6" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0" />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2560_37089"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2560_37089"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </>
  ),
});
